import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';

import { BASE } from '../../../../configs/routes.config';
import * as AuthActions from '../../../state/auth/auth.actions';
import { CtaButtonComponent } from '../../cta-button/cta-button.component';
import { PersonalPlanUpsellContent, PersonalPlanUpsellDialogData, PersonalPlanUpsellState } from './typings';

export const PERSONAL_PLAN_UPSELL_CONTENT: Record<PersonalPlanUpsellState, PersonalPlanUpsellContent> = {
  wheelLimitReached: {
    title: 'You’ve reached Free Plan limit',
    freePlanFeatures: ['1 wheel', '5 saved sessions'],
    personalPlanFeatures: ['Unlimited custom wheels and sessions', 'Reflection notes', 'Focus Categories', 'In-Depth Analytics'],
    primaryAction: 'Upgrade to Personal',
    secondaryAction: 'Not now',
  },
  oneSessionRemaining: {
    title: 'One free session remaining',
    freePlanFeatures: ['1 wheel', '5 saved sessions'],
    personalPlanFeatures: ['Unlimited custom wheels and sessions', 'Reflection notes', 'Focus Categories', 'In-Depth Analytics'],
    primaryAction: 'Upgrade to Personal',
    secondaryAction: 'Maybe later',
  },
  sessionLimitReached: {
    title: 'You’ve reached Free Plan limit',
    freePlanFeatures: ['1 wheel', '5 saved sessions'],
    personalPlanFeatures: ['Unlimited custom wheels and sessions', 'Reflection notes', 'Focus Categories', 'In-Depth Analytics'],
    reassurance: 'Your existing wheel and saved sessions remain available.',
    primaryAction: 'Upgrade to Personal',
    secondaryAction: 'Maybe later',
  },
  additionalSessionRejected: {
    title: 'You’ve reached Free Plan limit',
    freePlanFeatures: ['1 wheel', '5 saved sessions'],
    personalPlanFeatures: ['Unlimited custom wheels and sessions', 'Reflection notes', 'Focus Categories', 'In-Depth Analytics'],
    reassurance: 'Your existing wheel and saved sessions remain available.',
    primaryAction: 'Upgrade to Personal',
    secondaryAction: 'Not now',
  },
};

@Component({
  selector: 'wil-personal-plan-upsell-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, CtaButtonComponent],
  templateUrl: './personal-plan-upsell-dialog.component.html',
  styleUrl: './personal-plan-upsell-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalPlanUpsellDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<PersonalPlanUpsellDialogComponent>);
  private readonly store = inject(Store);
  private readonly document = inject(DOCUMENT);
  private readonly data = inject<PersonalPlanUpsellDialogData>(MAT_DIALOG_DATA);

  public readonly content = PERSONAL_PLAN_UPSELL_CONTENT[this.data.state];

  public upgrade(): void {
    const returnUrl = this.document.location.href;

    this.store.dispatch(
      AuthActions.createUpgradeCheckoutSession({
        request: {
          targetPlan: 'personal',
          successUrl: returnUrl || `${this.document.location.origin}/${BASE}/wheel`,
          cancelUrl: returnUrl || `${this.document.location.origin}/${BASE}/wheel`,
        },
      })
    );
    this.dialogRef.close();
  }

  public dismiss(): void {
    this.dialogRef.close();
  }
}
